module.exports = __webpack_public_path__ + "static/ec6ef8ad-825f-41cb-ae16-f51d3f862163-250.4e31841d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/barkVase-ruby/ec6ef8ad-825f-41cb-ae16-f51d3f862163-250.jpg
// module id = 913
// module chunks = 168707334958949